import { render, staticRenderFns } from "./UsersManagementSideBar.vue?vue&type=template&id=28e59770&scoped=true"
import script from "./UsersManagementSideBar.vue?vue&type=script&lang=js"
export * from "./UsersManagementSideBar.vue?vue&type=script&lang=js"
import style0 from "./UsersManagementSideBar.vue?vue&type=style&index=0&id=28e59770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e59770",
  null
  
)

export default component.exports